module.exports = __webpack_public_path__ + "static/media/plaque_sapin_2020.bbfcff61.png";